/**
 * old 前缀为 auth 的请求
 * 后期将被替换掉
 * 减少使用
 */
import axios from "axios";
import { Message } from "element-ui";
import router from "@/router/premission.js";
import { getToken } from "./auth";
import { removeToken } from "@/utils/auth.js";
const service = axios.create({
  // baseURL: process.env.BASE_API,
  baseURL: process.env.DEV_API,
  timeout: 60000
});
service.interceptors.request.use(
  config => {
    config.headers["token"] = getToken();
    config.headers["dc-client"] = "21";
    return config;
  },
  error => {
    console.log(error);
    Promise.reject(error);
  }
);
service.interceptors.response.use(
  response => {
    let status = response.data.status >= 0 ? response.data.status : response.data.errcode;
    let message = response.data.error ? response.data.error : response.data.errmsg;
    console.log();
    if (status == 0) {
      return response.data;
    } else {
      if (status && (status === 4012 || status === 4040 || status === 4030)) {
        Message({
          message: message,
          type: "error",
          duration: 2 * 1000
        });
        setTimeout(() => {
          removeToken();
          if (!window.location.href.includes("login")) {
            router.push({ name: "login" });
            window.location.reload();
          }
        }, 2500);
        return Promise.reject(response.data.error);
      } else {
        if (response.data.status === 4011) message = "账号或密码错误";
        if (response.data.status === 4019) message = "账号已被停用 ";
        Message({
          message: message,
          type: "error",
          duration: 2 * 1000
        });
        return Promise.reject(response.data.error);
      }
    }
  },
  error => {
    Message({
      message: "系统繁忙，请稍后重试！",
      type: "error",
      duration: 2 * 1000
    });
    return Promise.reject(error);
  }
);
export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js